/**
 *
 * Asynchronously loads the component for QuestionComment
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
